import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ResponseBase} from "../../data";
import {EfeLog} from "../../data/efeLog";

export interface EfeLogState {
    isLoading: boolean;
    error: ResponseBase | null;
    logList: EfeLog[];
    logCount: number;
}

const initialState: EfeLogState = {
    isLoading: false,
    error: null,
    logList: [],
    logCount: 0,
};

const efeLogSlice = createSlice({
    name: "efeLogSlice",
    initialState,
    reducers: {
        setLoading(state, action: PayloadAction<boolean>) {
            state.isLoading = action.payload;
        },
        setLogList(state, action: PayloadAction<EfeLog[]>) {
            state.logList = action.payload;
            state.isLoading = false;
        },
        setLogCount(state, action: PayloadAction<number>) {
            state.logCount = action.payload;
        },
        setError(state, action: PayloadAction<ResponseBase | null>) {
            state.isLoading = false;
            state.error = action.payload;
        }
    }
});

export const efeLogActions = efeLogSlice.actions;
export default efeLogSlice;
